import {API_ENDPOINTS} from 'config';
import {ApiService} from '../apiService';

class NoResident extends ApiService {
    getNoResidents(params) {
        return this.get(API_ENDPOINTS.noResident.root, params);
    }
}

export default (new NoResident())